import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";

// Profesjonelt stilsett
const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 11,
    padding: 40,
    lineHeight: 1.6,
    color: "#333",
  },
  header: {
    fontSize: 20,
    marginBottom: 20,
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: 1.5,
  },
  section: {
    marginBottom: 20,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
  box: {
    border: "1pt solid #ccc",
    padding: 10,
    borderRadius: 4,
    backgroundColor: "#f9f9f9",
  },
  tableHeader: {
    backgroundColor: "#eee",
    padding: 8,
    fontWeight: "bold",
  },
  tableRow: {
    padding: 8,
    borderBottom: "1pt solid #ddd",
  },
  bold: {
    fontWeight: "bold",
  },
  total: {
    marginTop: 12,
    textAlign: "right",
    fontSize: 12,
    fontWeight: "bold",
  },
});

const InvoicePDF = ({
  locations = [],
  unitPrice = 0,
  generatedBillingNumber,
  kontonr,
  navn,
  orgnr,
  createdAt,
}) => {
  const total = locations.length * unitPrice;

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <Text style={styles.header}>Faktura</Text>

        <View style={styles.section}>
          <View style={styles.row}>
            <View>
              <Text style={styles.label}>Fra:</Text>
              <Text>{navn}</Text>
              <Text>{orgnr !== "Ikke oppgitt" ? "Org.nr: " + orgnr : ""}</Text>
              <Text>kontonr: {kontonr}</Text>
            </View>
            <View>
              <Text style={styles.label}>Til:</Text>
              <Text>Lie Tech</Text>
              <Text>steffen@mapli.no</Text>
            </View>
          </View>
        </View>

        <View style={styles.section}>
          <View style={styles.row}>
            <Text>Fakturanr: #{generatedBillingNumber}</Text>
            <Text>
              Dato:{" "}
              {new Date(createdAt).toLocaleDateString("no-NO", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })}
            </Text>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.label}>Beskrivelse:</Text>
          <Text>Utfylt skjema for følgende lokasjoner:</Text>
          <View style={styles.box}>
            <Text>{locations.join(", ") || "Ingen lokasjoner"}</Text>
          </View>
        </View>

        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.tableHeader}>Antall lokasjoner</Text>
            <Text style={styles.tableHeader}>Pris per stykk</Text>
            <Text style={styles.tableHeader}>Sum</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.tableRow}>{locations.length}</Text>
            <Text style={styles.tableRow}>{unitPrice},–</Text>
            <Text style={styles.tableRow}>{total},–</Text>
          </View>
        </View>

        <Text style={styles.total}>Total fakturert: {total},–</Text>
      </Page>
    </Document>
  );
};

export const InvoicePDFDownloadLink = ({
  locations,
  unitPrice,
  generatedBillingNumber,
  kontonr,
  navn,
  orgnr,
  createdAt,
}) => (
  <PDFDownloadLink
    document={
      <InvoicePDF
        locations={locations}
        unitPrice={unitPrice}
        generatedBillingNumber={generatedBillingNumber}
        kontonr={kontonr}
        navn={navn}
        orgnr={orgnr}
        createdAt={createdAt}
      />
    }
    fileName='faktura.pdf'
    style={{ textDecoration: "none", color: "#007bff", fontWeight: "bold" }}>
    {({ loading }) => (loading ? "Laster PDF..." : "Last ned faktura")}
  </PDFDownloadLink>
);
